import { useTranslation as useI18nTranslation } from "react-i18next";
import translations from "../i18n/locales/fr.json";

type DotPrefix<T extends string> = T extends "" ? "" : `.${T}`;

type DotNestedKeys<T> = (
  T extends object
    ? {
        [K in keyof T]: `${K & string}${DotPrefix<DotNestedKeys<T[K]>>}`;
      }[keyof T]
    : ""
) extends infer D
  ? Extract<D, string>
  : never;

export type TranslationKeys = DotNestedKeys<typeof translations>;

export default function useCustomTranslation() {
  const { t, ...rest } = useI18nTranslation();

  const typedT = (key: TranslationKeys, options?: Record<string, unknown>) =>
    t(key, options);

  return {
    t: typedT,
    ...rest,
  };
}
